import { useCallback, useState } from 'react';
import moment, { Moment } from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import { AirflowDashboardHandler } from '@api/airflow-dashboard-handler';
import { errorAlert, successAlert } from '@components/toastify/notify-toast';

/*
 * Manages the Trigger DAG dialog's logical-date field and submit flow
 */
export function useTriggerDagDialog(dagId: string, onClose: () => void) {
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
    const [logicalDate, setLogicalDate] = useState<Moment | null>(() => moment.utc());
    const [isSubmitting, setIsSubmitting] = useState(false);

    /*
     * Submits the trigger request, converting the selected local field value to a UTC ISO string
     */
    const handleSubmit = useCallback(async () => {
        setIsSubmitting(true);
        try {
            await AirflowDashboardHandler.triggerDag(Env, dagId, {
                logical_date: logicalDate ? logicalDate.utc().toISOString() : undefined,
            });
            successAlert(`Triggered a new run for "${dagId}".`);
            onClose();
        } catch {
            errorAlert(`Failed to trigger DAG "${dagId}".`);
        } finally {
            setIsSubmitting(false);
        }
    }, [Env, dagId, logicalDate, onClose]);

    return { logicalDate, setLogicalDate, isSubmitting, handleSubmit };
}
